import { useIntl } from 'react-intl';
import { enUS, es } from 'date-fns/locale';

export const useLocale = () => {
  const intl = useIntl();
  return intl.locale === 'es' ? es : enUS;
};
